'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateGridItemAvailability = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _Helpers = require('common/Helpers');

var _Flow = require('components/Flow');

var _Flow2 = _interopRequireDefault(_Flow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */

var isFlow = function isFlow() {
  return _Flow2.default && window.Flow.cart && window.Flow.getExperience();
};

var checkVariantStock = function checkVariantStock(swatch, availability) {
  var variantAvailable = availability > 0;
  var $thisItemBtn = swatch.closest('.product-grid-item').find('.cart-btn');
  var svgPlus = '<span class="collection-quickview-plus"><svg width="11px" height="11px" viewBox="0 0 11 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="QUICKSHOP" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="COLLECTION_1480px_Quickshop_Main_Hover" transform="translate(-947.000000, -964.000000)"> <polygon id="icon-plus-bold" fill="#17151A" points="958 968.826531 953.173469 968.826531 953.173469 964 951.826531 964 951.826531 968.826531 947 968.826531 947 970.173469 951.826531 970.173469 951.826531 975 953.173469 975 953.173469 970.173469 958 970.173469"></polygon> </g> </g></svg></span>';

  var $cta_addToCart = swatch.closest('.product-grid-item').find('.collection-reg-atc');
  var $cta_quickview = swatch.closest('.product-grid-item').find('.collection-quickview-trigger');

  if (variantAvailable) {
    $thisItemBtn.parent().removeClass('is-disabled');
  } else {
    $thisItemBtn.parent().addClass('is-disabled');
  }

  if (swatch.hasClass('js-sunglasses-swatch')) {
    var variantReference = swatch.attr('data-variant-color');

    var variantUrl = swatch.closest('.product-grid-item-inside').find('.js-sunglasses-image[data-variant="' + variantReference + '"]').closest('.variant-link').attr('href') || '';
  } else {
    var variantReference = swatch.attr('data-variant-id');
    var variantUrl = swatch.closest('.product-grid-item').find('.variant-link[href-' + variantReference + ']').attr('href-' + variantReference);
  }

  if (variantUrl.indexOf('?') > 0) {
    var newBtnUrl = variantUrl + '&out-of-stock';
  } else {
    var newBtnUrl = variantUrl + '?out-of-stock';
  }

  var $productTag = swatch.closest('.product-grid-item').find('.product-tag').eq(0);
  var tagData = swatch.attr('data-tag');

  if (variantAvailable == false) {
    $cta_quickview.addClass('hidden');
    $cta_addToCart.addClass('collection-reg-atc--full');
    $cta_addToCart.removeClass('add-to-cart').addClass('button--grey-gradient out-of-stock-btn').removeAttr('add-to-cart');
    $cta_addToCart.attr('href', newBtnUrl);
    $cta_addToCart.find('span').text('Out of Stock');

    if ($productTag.length < 1 && !$productTag.hasClass('js-priority-tag')) {
      swatch.closest('.product-grid-item').append('<span class="product-tag tag-red">SOLD OUT</span>');
    } else if (!$productTag.hasClass('js-priority-tag')) {
      if (tagData == '') {
        $productTag.text('SOLD OUT').addClass('tag-red').removeClass('tag-black').removeClass('tag-empty');
        $productTag.css({ 'visibility': 'visible', 'width': 'unset', 'padding': '' });
      } else if (tagData == 'new') {
        $productTag.text('SOLD OUT').addClass('tag-red').removeClass('tag-black').removeClass('tag-empty');
        $productTag.css({ 'visibility': 'visible', 'width': 'unset', 'padding': '' });
      }
    }
  } else {
    if ($thisItemBtn.hasClass('out-of-stock-btn')) {
      if ($(window).width() >= 992) {
        $cta_quickview.removeClass('hidden');
        $cta_addToCart.removeClass('collection-reg-atc--full');
        $cta_addToCart.addClass('add-to-cart').removeClass('button--grey-gradient out-of-stock-btn').attr('add-to-cart', '');
        $cta_addToCart.removeAttr('href');
        $cta_addToCart.find('span').text('Add to Cart').css('display', 'block');
        $cta_quickview.removeClass('button--grey-gradient out-of-stock-btn').addClass('button--black-skeleton').removeAttr('add-to-cart', '');
        $cta_quickview.find('span').html(svgPlus + ' Quickview');
      } else {
        $thisItemBtn.removeClass('button--grey-gradient out-of-stock-btn').addClass('add-to-cart button--black-gradient').attr('add-to-cart', '');
        $thisItemBtn.find('span').text('Add to Cart');
      }
    }

    if (tagData == 'new' && variantAvailable == true && !$productTag.hasClass('js-priority-tag')) {
      $productTag.text('New').addClass('tag-black').removeClass('tag-red');
      $productTag.css('visibility', 'visible');
    } else if (!$productTag.hasClass('js-priority-tag')) {
      $productTag.css({ 'visibility': 'hidden', 'width': 0, 'padding': 0 });
    }
  }
};

var comparePriceCheck = function comparePriceCheck(selector, variantId) {
  var $comparePriceEntry = selector.closest('.product-grid-item').find('.compare-price');
  var $actualPriceEntry = selector.closest('.product-grid-item').find('.actual-price');
  var comparePrice = '';

  if (isFlow()) {
    if (window.Flow.cache.localizedVariants.getById(variantId).prices.hasOwnProperty('compare_at')) {
      comparePrice = window.Flow.cache.localizedVariants.getById(variantId).prices.compare_at.label;
    }
    window.Flow.variants.localize();
  } else {
    comparePrice = selector.attr('data-compare-price');
    $comparePriceEntry.html(comparePrice);
  }

  if (comparePrice == '' || comparePrice == undefined || comparePrice == null) {
    $comparePriceEntry.empty();
    $actualPriceEntry.removeClass('sale-price');
  } else {
    $comparePriceEntry.html(comparePrice);
    $actualPriceEntry.addClass('sale-price');
  }
};

var priceCheck = function priceCheck(selector, variantId) {
  if (isFlow()) {
    var variantPrice = window.Flow.cache.localizedVariants.getById(variantId).prices.item.label;
  } else {
    var variantPrice = selector.attr('data-variant-price');
  }
  selector.closest('.product-grid-item').find('.actual-price').html(variantPrice);
};

var childPriceCheck = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(selector, childVariantHandle) {
    var _ref2, variants, _variants$, variantId, variantPrice, variantCompareAtPrice, over100, price, _over, comparePrice;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch('/products/' + childVariantHandle + '.js').then(function (res) {
              return res.json();
            });

          case 3:
            _ref2 = _context.sent;
            variants = _ref2.variants;
            _variants$ = variants[0], variantId = _variants$.id, variantPrice = _variants$.price, variantCompareAtPrice = _variants$.compare_at_price;


            if (isFlow()) {
              window.Flow.variants.load({
                variants: [variantId],
                experience: window.Flow.session.getExperience(),
                success: function success(status, variants) {
                  selector.closest('.product-grid-item').find('.actual-price').html(variants[variantId].prices.item.label);
                  if (variants[variantId].prices.compare_at) {
                    selector.closest('.product-grid-item').find('.compare-price').html(variants[variantId].prices.compare_at.label);
                  }
                },
                error: function error(status, _error) {
                  console.log(status, _error);
                }
              });
            } else {
              over100 = variantPrice / 100;
              price = over100 % 1 == 0 ? over100 : over100.toFixed(2);


              selector.closest('.product-grid-item').find('.actual-price').html('$' + price);
            }

            if (variantCompareAtPrice === null) {
              selector.closest('.product-grid-item').find('.compare-price').hide();
              selector.closest('.product-grid-item').find('.actual-price').removeClass('red');
            } else {
              _over = variantCompareAtPrice / 100;
              comparePrice = _over % 1 == 0 ? _over : _over.toFixed(2);


              if (!isFlow()) {
                selector.closest('.product-grid-item').find('.compare-price').html('$' + comparePrice);
              }

              selector.closest('.product-grid-item').find('.compare-price').show();
              selector.closest('.product-grid-item').find('.actual-price').addClass('red');
            }
            _context.next = 13;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context['catch'](0);

            console.error(_context.t0);

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[0, 10]]);
  }));

  return function childPriceCheck(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var swatchClickEvent = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3($self) {
    var isStrapCollection, $theParent, childVariantHandle, optionName, optionValue, optionNameAttr, optionValueAttr, variants, variantIdFromHandle, variantIdFromDom, variantId, updateChildVariantImage, updateActiveSwatch, triggerChangeEvent, updateAnchorHrefs, availability;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!$self.hasClass('is-active')) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt('return', false);

          case 2:
            isStrapCollection = window.prg.collection.handle === null;
            $theParent = $self.closest('.product-grid-item');
            childVariantHandle = $self.attr('data-child-variant');
            optionName = $self.data('option-name');
            optionValue = $self.data('option-value');
            optionNameAttr = '[data-option-name="' + optionName + '"]';
            optionValueAttr = '[data-option-Value="' + optionValue + '"]';
            variants = State.get('variant');
            variantIdFromHandle = variants[childVariantHandle];
            variantIdFromDom = $self.data('variant-id');
            variantId = variantIdFromHandle || variantIdFromDom;

            updateChildVariantImage = function updateChildVariantImage() {
              $theParent.find('.prod-grid-image-link').hide().filter('' + optionNameAttr + optionValueAttr).css({ display: 'block' });
            };

            updateActiveSwatch = function updateActiveSwatch() {
              $theParent.find('.variant-swatch').removeClass('is-active').filter($self).addClass('is-active');
            };

            triggerChangeEvent = function () {
              var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var container, id;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        container = (0, _Helpers.getContainer)({ self: $self, type: 'product' });
                        id = container.dataset.containerId;

                        PubSub.publish(_Constants2.default.updateVariantId, { id: id, variantId: variantId });

                      case 3:
                      case 'end':
                        return _context2.stop();
                    }
                  }
                }, _callee2, undefined);
              }));

              return function triggerChangeEvent() {
                return _ref4.apply(this, arguments);
              };
            }();

            updateAnchorHrefs = function updateAnchorHrefs() {
              var newUrl = window.location.pathname + '/products/' + childVariantHandle;

              $theParent.find('a:not(.prod-grid-image-link)').each(function (index, link) {
                return $(link).attr('href', newUrl);
              });
            };

            availability = isStrapCollection ? $self.data('available') : State.get('inventory')[childVariantHandle];


            updateChildVariantImage();
            updateActiveSwatch();
            triggerChangeEvent();
            updateAnchorHrefs();
            checkVariantStock($self, availability);

            if (childVariantHandle) {
              childPriceCheck($self, childVariantHandle);
            } else {
              comparePriceCheck($self, newVariantId);
              priceCheck($self, newVariantId);
            }

          case 24:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function swatchClickEvent(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var bindUIActions = function bindUIActions() {
  var tabletBreak = 768;
  var tabletLargeBreak = 993;
  var screenWidth = $(window).width();
  var collectionTileOptions = {
    centerMode: true,
    centerPadding: '40px'
  };

  if (screenWidth > tabletLargeBreak) {} else if (screenWidth < tabletBreak) {
    $('.js-collection-tiles').slick(collectionTileOptions);
  }

  $(window).on('resize', function () {
    var width = $(window).width();

    if (width < tabletBreak) {
      if (!$('.js-collection-tiles').hasClass('slick-slider')) {
        $('.js-collection-tiles').slick(collectionTileOptions);
      }
    } else if ($('.js-collection-tiles').hasClass('slick-slider')) {
      $('.js-collection-tiles').slick('unslick');
    }
  });

  $('.filter-mb').on('click', function () {
    $('body, html').toggleClass('lock-bg');
  });

  $('[data-tab]').on('click', function () {
    $(this).addClass('is-active').siblings('[data-tab]').removeClass('is-active');
    $(this).closest('.collection-mobile-filter').find('[data-content=' + $(this).data('tab') + ']').addClass('is-active').removeClass('disable-events').siblings('[data-content]').removeClass('is-active');
    var activeFilter = $(this).attr('data-active-filter');

    setTimeout(function () {
      $('[data-filter-group-btn-mobile="' + activeFilter + '"]').eq(0).trigger('click');
      if ($('[data-content="2"]').hasClass('is-active')) {
        $('.mobile-sort-by-options').addClass('is-loaded');
      }
      if ($('[data-content="1"]').hasClass('is-active')) {
        $('.collection-filter-options-mobile').addClass('is-loaded');
      }
    }, 750);
    setTimeout(function () {
      if ($('[data-content="1"]').hasClass('is-active')) {
        $('.mobile-filter-actions').addClass('is-loaded');
      }
    }, 1000);
  });

  $('.sunglasses-product-item .prod-image-wrap .variant-link:first-child .img-secondary').addClass('top-hover');

  $(document).on('click', '.add-to-cart', function (e) {
    e.preventDefault();
  });

  $(document).on('click', '.product-grid-item .variant-swatch', function () {
    var self = $(this);

    swatchClickEvent(self);
  });

  $('.template__collection [add-to-cart]').on('click', function () {
    window.optimizely = window.optimizely || [];
    window.optimizely.push(['trackEvent', 'add_to_cart']);
  });

  var $jsSeoReadMore = $('.js-seo-read-more');
  var $jsSeoReadLess = $('.js-seo-read-less');
  var $jsSeoSecondary = $('.js-seo-secondary');

  var $jsSeoReadMore2 = $('.js-seo-read-more-2');
  var $jsSeoReadLess2 = $('.js-seo-read-less-2');
  var $jsSeoSecondary2 = $('.js-seo-secondary-2');

  $(document).on('click', '.js-seo-toggle', function () {
    var accordionSpeed = 300;

    if ($jsSeoReadMore.hasClass('active')) {
      $jsSeoReadMore.removeClass('active');
      $jsSeoReadLess.addClass('active');
      $jsSeoSecondary.slideDown(accordionSpeed);
    } else {
      $jsSeoReadLess.removeClass('active');
      $jsSeoReadMore.addClass('active');
      $jsSeoSecondary.slideUp(accordionSpeed);
    }
  });

  $(document).on('click', '.js-seo-toggle-2', function () {
    var accordionSpeed = 300;

    if ($jsSeoReadMore2.hasClass('active')) {
      $jsSeoReadMore2.removeClass('active');
      $jsSeoReadLess2.addClass('active');
      $jsSeoSecondary2.slideDown(accordionSpeed);
    } else {
      $jsSeoReadLess2.removeClass('active');
      $jsSeoReadMore2.addClass('active');
      $jsSeoSecondary2.slideUp(accordionSpeed);
    }
  });

  $('[data-mobile-collections-dropdown]').on('click', function () {
    $(this).toggleClass('active');
    $('.js-mobile-collections-list').slideToggle(300);
  });
};

var updateGridItemAvailability = exports.updateGridItemAvailability = function updateGridItemAvailability() {
  $(_Dom2.default.collectionSwatch).filter('.is-active').each(function (index, swatch) {
    var $swatch = $(swatch);
    var childVariantHandle = $swatch.attr('data-child-variant');
    var availability = State.get('inventory')[childVariantHandle];

    checkVariantStock($swatch, availability);
  });
};

var init = function init() {
  bindUIActions();
};

exports.default = {
  init: init,
  bindActions: bindUIActions,
  checkVariantStock: checkVariantStock,
  updateGridItemAvailability: updateGridItemAvailability
};